import { render, staticRenderFns } from "./Adjustbalance.vue?vue&type=template&id=45c04325"
import script from "./Adjustbalance.vue?vue&type=script&lang=js"
export * from "./Adjustbalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports